<template>
	<SkillsEdit
		:value="value"
		none-text="Es ist keine Anwendung von spezieller Software nötig"
		self-assessment-placeholder="- Mindesterfahrung auswählen -"
		meta-skill-property="skillSoftwareSpecial"
		keyword-placeholder="Software, Programme eintragen..."
		keyword-placeholder-further="Weitere Software eintragen..."
		type="job-profile"
		@validChange="$emit('validChange', $event)"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import SkillsEdit from "@/vue/common/skill/Edit"
import {mapState} from "vuex";

export default {

	components: {
		SkillsEdit,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
	},

	computed: {
		...mapState('meta', ['meta']),
	}
}
</script>
